export const easeInEaseOut = () => {};
export default {};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/LayoutAnimation.js